import { Controller } from "@hotwired/stimulus"

// data-controller="select-insert"
export default class extends Controller {
  static values = {
    id: Number,
    text: String,
    target: String
  }

  connect() {
    this.select = document.querySelector(this.targetValue)

    if (!this.select.tomselect) {
      setTimeout(() => this.connect(), 50)
      return
    }

    this.addOption()
    this.setValue()
    this.closeModal()
  }

  addOption() {
    // evita duplicar
    if (!this.select.tomselect.options[this.idValue]) {
      this.select.tomselect.addOption({
        value: this.idValue,
        text: this.textValue
      })
    }
  }

  setValue() {
    this.select.tomselect.setValue(this.idValue)
  }

  closeModal() {
    this.dispatch("success", {
      detail: { success: true },
      bubbles: true
    })
  }
}